export const getColCount = (
    size: number,
    type?: 'question' | 'storybook' | 'storybook-public' | 'campaign',
) => {
    if (size < 475) return Math.floor(size / (type === 'question' ? 310 : 300))
    if (type === 'question' && size < 980) return Math.floor(size / 400)
    return Math.floor(size / (type === 'question' ? 480 : type === 'storybook' ? 380 : 320))
}
